// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"emptyContent_wrapper__3mo-k","svg":"emptyContent_svg__2zyIe"};